import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './app.scss';
import { LoginPage } from './pages/login';
import { AuthProvider } from './services/auth.service';
import { useContext, createContext, useState, useEffect } from 'react';
import { SelectorPage } from './pages/selector';
import { HomePage } from './pages/home';
import { SimulatorPage } from './pages/simulator';
import { DatasPage } from './pages/datas';
import { AnalysisPage } from './pages/analysis';
import { DeltaPage } from './pages/delta';

/* -------------------------------------------------------------------------------- *\
|                               ClockContext
\* -------------------------------------------------------------------------------- */
export const ClockContext = createContext<string>("");
export const useClockContext = () =>
{
    return useContext(ClockContext);
};
/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
function App()
{
    const [clock, setClock] = useState<string>('');

    /* -------------------------------------------------------------------------------- *\
    |                               refreshTime
    \* -------------------------------------------------------------------------------- */
    function refreshTime()
    {
        const now = new Date();
        setClock(now.toLocaleTimeString());
    }
    useEffect(() => {
        const interval = setInterval(() =>
        {
            refreshTime();
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <BrowserRouter basename="/">
            <ClockContext.Provider value={clock}>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/import" element={<SelectorPage />} />
                        <Route path="/datas" element={<DatasPage />} />
                        <Route path="/simulator" element={<SimulatorPage />} />
                        <Route path="/analysis" element={<AnalysisPage />} />
                        <Route path="/delta" element={<DeltaPage />} />
                        <Route path="/login" element={<LoginPage />} />
                    </Routes>
                </AuthProvider>
            </ClockContext.Provider>
        </BrowserRouter>
    );
}

export default App;
